import { compose } from 'recompose';
import { withTranslation } from 'react-i18next';
import NavigationTasks from './navigationTasks';

const enhance = compose(
  withTranslation(['tasks']),
);
export default enhance(NavigationTasks);
